import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root'
})
export class MatIconRegistryService {

	icons = [

    {name: 'twitter', url: '/assets/social-media-icons/twitter.svg'},
    {name: 'facebook', url: '/assets/social-media-icons/facebook.svg'},
    {name: 'whatsapp', url: '/assets/social-media-icons/whatsapp.svg'},
    {name: 'twitch', url: '/assets/social-media-icons/twitch.svg'},
    {name: 'twitter', url: '/assets/social-media-icons/twitter.svg'},
    {name: 'spotify', url: '/assets/social-media-icons/spotify.svg'},
    {name: 'instagram', url: '/assets/social-media-icons/instagram.svg'},
    {name: 'youtube', url: '/assets/social-media-icons/youtube.svg'},
    {name: 'tiktok', url: '/assets/social-media-icons/tiktok.svg'},
    {name: 'linkedin', url: '/assets/social-media-icons/linkedin.svg'},
    {name: 'pinterest', url: '/assets/social-media-icons/pinterest.svg'},
    {name: 'dribbble', url: '/assets/social-media-icons/dribbble.svg'},
    {name: 'behance', url: '/assets/social-media-icons/behance.svg'},
    {name: 'menu', url: '/assets/social-media-icons/menu.svg'},

	];

	constructor(
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) { }

	initializeAppIcons() {

		this.icons.map( icon => {
			this.matIconRegistry.addSvgIcon(
				`app_${icon.name}`,
				this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
			);
		});
	}

}
